import React, { memo } from 'react';
import { useFormState } from 'react-final-form';
import { Button } from 'js/components/common/Button';
import buildClassName from 'js/utils/classNameBuilder.util';
import { DatePicker } from 'js/components/common/Fields/DatePicker';

import style from './TableAnotherPeriodFilter.scss';

export const TableAnotherPeriodFilter = memo((props) => {
    const { from, until, submit: { title, getIsDisabled }, classNames } = props;
    const { values } = useFormState();

    return (
        <div className={`${buildClassName(['anotherPeriodContainer'], style, classNames)} cms-table-another-period`}>
            <DatePicker
                {...from}
                name="from"
                className={buildClassName(['filter'], style, classNames)}
            />
            <DatePicker
                {...until}
                name="until"
                className={buildClassName(['filter'], style, classNames)}
            />
            <div className={buildClassName(['anotherPeriodSubmit'], style, classNames)}>
                <Button
                    type="submit"
                    view="secondary"
                    disabled={getIsDisabled({ from: values.from, until: values.until })}
                >
                    {title}
                </Button>
            </div>
        </div>
    );
});
